import { Component, Input } from '@angular/core';

import { GfTranslateService } from '../../core/services/core.translate.service';

@Component({
    selector: 'audio-alert',
    template: require('./audio-alert.component.html'),
})
export class AudioAlertComponent {
    @Input() silentAudioUrl = '/core/sound/silence-1sec.mp3';

    audioEnabled = true;
    alertMessage = 'Checking audio...';
    tryCount = 0;

    constructor(
        private gfTranslateService: GfTranslateService,
    ) {}

    ngAfterViewInit(): void {
        this.testAudioPlayback();
    }

    testAudioPlayback(): void {
        const audio = new Audio(this.silentAudioUrl);

        audio.play()
            .then(() => {
                this.audioEnabled = true;
            })
            .catch((err) => {                
                this.audioEnabled = false;
            }).finally(() => {
                this.tryCount += 1;
                this.setMessage(this.audioEnabled, this.tryCount);
            });
    }

    private setMessage(enabled: boolean, retryCount: number): void {
        if (enabled) {
            this.alertMessage = '';
            return;
        }

        this.alertMessage = (retryCount > 1) ?
            this.gfTranslateService.translate('Notification sounds could not be enabled. Please check your browser and system audio settings.') :
            this.gfTranslateService.translate('Click to enable sounds')
        ;
    }
}